import { Link } from "react-router-dom"
import { Mail, Phone, MapPin, Facebook, Twitter, Instagram, Linkedin } from "lucide-react"
import { SCHOOL, SITE_NAV } from "../../lib/constants"

export function SiteFooter() {
  return (
    <footer className="mt-auto bg-ink-950 text-ink-300">
      <div className="container mx-auto px-4 py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <div className="w-12 h-12 rounded-full bg-white p-1">
                <img src="/logo.png" alt={SCHOOL.name} className="w-full h-full object-contain rounded-full" />
              </div>
              <div>
                <div className="text-white font-bold text-sm leading-tight">YMS COE</div>
                <div className="text-[10px] uppercase tracking-wider text-gold-400">Kano Ghari</div>
              </div>
            </div>
            <p className="text-sm leading-relaxed text-ink-400">
              A premier College of Education dedicated to nurturing world-class teachers through excellence,
              integrity and service to community.
            </p>
            <div className="flex items-center gap-3 mt-5">
              {[Facebook, Twitter, Instagram, Linkedin].map((Icon, i) => (
                <a key={i} href="#" className="w-9 h-9 grid place-items-center rounded-full bg-ink-900 hover:bg-brand-700 transition-colors" aria-label="social">
                  <Icon className="w-4 h-4 text-ink-300" />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-white font-semibold text-sm mb-4 uppercase tracking-wider">Explore</h4>
            <ul className="space-y-2.5 text-sm">
              {SITE_NAV.slice(0, 6).map(item => (
                <li key={item.href}><Link to={item.href} className="hover:text-gold-300 transition-colors">{item.label}</Link></li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold text-sm mb-4 uppercase tracking-wider">Resources</h4>
            <ul className="space-y-2.5 text-sm">
              {SITE_NAV.slice(6).map(item => (
                <li key={item.href}><Link to={item.href} className="hover:text-gold-300 transition-colors">{item.label}</Link></li>
              ))}
              <li><Link to="/portal/login" className="hover:text-gold-300 transition-colors">Student Portal</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold text-sm mb-4 uppercase tracking-wider">Contact</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-2"><MapPin className="w-4 h-4 mt-0.5 text-gold-400 shrink-0" /><span>{SCHOOL.address}</span></li>
              <li className="flex items-center gap-2"><Phone className="w-4 h-4 text-gold-400 shrink-0" /><span>{SCHOOL.phone}</span></li>
              <li className="flex items-center gap-2"><Mail className="w-4 h-4 text-gold-400 shrink-0" /><a href={`mailto:${SCHOOL.email}`} className="hover:text-gold-300">{SCHOOL.email}</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-ink-800 flex flex-col sm:flex-row justify-between gap-3 text-xs text-ink-500">
          <p>© {new Date().getFullYear()} {SCHOOL.fullName}. All rights reserved.</p>
          <div className="flex items-center gap-4">
            <Link to="/privacy" className="hover:text-ink-300">Privacy</Link>
            <Link to="/terms" className="hover:text-ink-300">Terms</Link>
            <span>Built with excellence • Powered by YMS Tech</span>
          </div>
        </div>
      </div>
    </footer>
  )
}
